/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LoginUser
 */
export interface LoginUser {
    /**
     * 
     * @type {string}
     * @memberof LoginUser
     */
    accessToken: string;
    /**
     * 
     * @type {number}
     * @memberof LoginUser
     */
    accountType: LoginUserAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof LoginUser
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LoginUser
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof LoginUser
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof LoginUser
     */
    identityProviderToken?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof LoginUser
     */
    roles: Array<LoginUserRolesEnum>;
}


/**
 * @export
 */
export const LoginUserAccountTypeEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;
export type LoginUserAccountTypeEnum = typeof LoginUserAccountTypeEnum[keyof typeof LoginUserAccountTypeEnum];

/**
 * @export
 */
export const LoginUserRolesEnum = {
    User: 'user',
    Trainer: 'trainer',
    Admin: 'admin'
} as const;
export type LoginUserRolesEnum = typeof LoginUserRolesEnum[keyof typeof LoginUserRolesEnum];


/**
 * Check if a given object implements the LoginUser interface.
 */
export function instanceOfLoginUser(value: object): value is LoginUser {
    if (!('accessToken' in value) || value['accessToken'] === undefined) return false;
    if (!('accountType' in value) || value['accountType'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('username' in value) || value['username'] === undefined) return false;
    if (!('roles' in value) || value['roles'] === undefined) return false;
    return true;
}

export function LoginUserFromJSON(json: any): LoginUser {
    return LoginUserFromJSONTyped(json, false);
}

export function LoginUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginUser {
    if (json == null) {
        return json;
    }
    return {
        
        'accessToken': json['access_token'],
        'accountType': json['accountType'],
        'id': json['id'],
        'email': json['email'],
        'username': json['username'],
        'identityProviderToken': json['identityProviderToken'] == null ? undefined : json['identityProviderToken'],
        'roles': json['roles'],
    };
}

export function LoginUserToJSON(json: any): LoginUser {
    return LoginUserToJSONTyped(json, false);
}

export function LoginUserToJSONTyped(value?: LoginUser | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'access_token': value['accessToken'],
        'accountType': value['accountType'],
        'id': value['id'],
        'email': value['email'],
        'username': value['username'],
        'identityProviderToken': value['identityProviderToken'],
        'roles': value['roles'],
    };
}

